import React from "react";
import "./education-card.css";

function EducationCard({ item }) {
  return (
    <div className="education-card">
      <div className="education-info">
        <div className="education-header">
          <div className="education-title-section">
            <label className="degree-title">{item.degree}</label>
            <div className="institution-name">
              <label>{item.institution}</label>
            </div>
            <div className="education-location">
              <label>{item.location}</label>
            </div>
          </div>
          <div className="education-meta">
            <span className="education-duration">{item.duration}</span>
            <span className="education-cgpa">CGPA: {item.cgpa}</span>
          </div>
        </div>
        <div className="education-description">
          <p>{item.description}</p>
        </div>
      </div>
    </div>
  );
}

export default EducationCard;
